import { render, staticRenderFns } from "./AccessField.vue?vue&type=template&id=271a0161&scoped=true&"
import script from "./AccessField.vue?vue&type=script&lang=js&"
export * from "./AccessField.vue?vue&type=script&lang=js&"
import style0 from "./AccessField.vue?vue&type=style&index=0&id=271a0161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a0161",
  null
  
)

export default component.exports